import {RDate} from '@app/core/models/rDate.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import * as moment from 'moment';
import {Group} from '@app/core/models/group.model';
import {User} from '@app/core/models/user.model';
import {GroupUser} from '@app/core/models/groupUser.model';

export class SupplementalSalary extends BaseModel {
	public id: number;
	public name: string;
	public active: boolean;
	public auto_add_new_users: boolean;
	public start: string;
	public end: string;
	public supplement: number;
	public days_of_week: string[];
	public groups: Group[];
	public group_users: GroupUser[];
	public created_at: RDate;
	public updated_at: RDate;
	public payment_number: string;

	constructor(
		tenantTZ: string,
		interService: InternationalizationService
	) {
		super(tenantTZ, interService);
	}

	public groupString(): string {
		let groupString = '';

		this.groups.forEach((g, i) => {
			groupString += g.group_name;
			if (i !== this.groups.length - 1) {
				groupString += ', ';
			}
		});

		return groupString;
	}

	public databaseDaysOfWeek(): string[] {
		const trueIndexes = [];
		this.days_of_week.forEach((active, index) => {
			if (active) {
				trueIndexes.push(active);
			}
		});

		return trueIndexes;
	}

	public daysOfWeekString(): string {
		const indexes = this.days_of_week.map(Number);

		const hasFriday = indexes.indexOf(4) !== -1;
		const hasSaturday = indexes.indexOf(5) !== -1;
		const hasSunday = indexes.indexOf(6) !== -1;

		const count = indexes.length;

		if (count === 7) {
			return this.interService.translate.instant('time_allDays');
		} else if (count === 5 && !hasSunday && !hasSaturday) {
			return this.interService.translate.instant('time_allWeekdays');
		} else if (count === 3 && hasFriday && hasSaturday && hasSunday) {
			return this.interService.translate.instant('time_fridayToSunday');
		} else if (count === 2 && hasSaturday && hasSunday) {
			return this.interService.translate.instant('time_saturdayAndSunday');
		} else if (count === 1) {
			const index = indexes[0];
			if (index === 6) {
				return moment.weekdays(0);
			} else {
				return moment.weekdays(index + 1);
			}
		} else {
			return String(count) + ' ' + this.interService.translate.instant('AVAILABILITIES.DAYS');
		}
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.supplement) {
			this.supplement = Number(input.supplement);
		}
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}
		if (input.groups) {
			this.groups = input.groups.map(groupInput => new Group(this.tenantTZ, this.interService).deserialize(groupInput));
		}
		if (input.group_users) {
			this.group_users = input.group_users.map(groupInput => new User(this.tenantTZ, this.interService).deserialize(groupInput));
		}

		return this;
	}
}
